import Breadcrumbs from '../common/Breadcrumbs';

function PlaylistPageHeader({ title, breadcrumbs }) {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-[#1B1B1B] sm:text-[32px]">{title}</h1>
      <Breadcrumbs items={breadcrumbs} className="mt-2" />
    </div>
  );
}

export default PlaylistPageHeader;
